// extracted by mini-css-extract-plugin
module.exports = {"articulos":"listadoArticulos-module--articulos--3fAg3"};